/*eslint-disable */
var $ = (window.jQuery = require('jquery'));
import Vue from 'vue';
import Router from 'vue-router';
import store from './store/store';

Vue.use(Router);

const router = new Router({
	//  const router {
	mode: 'history',
	canReuse: false,
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash
			};
		} else {
			return {
				x: 0,
				y: 0
			};
		}
	},
	routes: [
		{
			path: '*',
			redirectTo: '/'
		},
		{
			path: '/',
			name: 'Quizzort',
			component: () => import(/* webpackChunkName: "Quizzort" */ './view/Quizzort/index.vue'),
			props: (route) => ({
				to: route.query.to,
				stage: route.query.stage,
				bg: route.query.bg
			}),
			beforeEnter: (to, from, next) => {
				document.title = 'Quizzort';
				next();
			}
		},
		{
			path: '/leibniz-says/',
			name: 'leibnizSaysLevel1',
			component: () =>
				import(/* webpackChunkName: "leibnizSaysLevel1" */ './view/leibnizSaysGame/Level1/index.vue'),
			props: (route) => ({
				to: route.query.to,
				stage: route.query.stage,
				bg: route.query.bg
			}),
			beforeEnter: (to, from, next) => {
				document.title = 'Quizzort - Leibniz Says';
				next();
			}
		},
		{
			path: '/leibniz-says/level2/',
			name: 'leibnizSaysLevel2',
			component: () =>
				import(/* webpackChunkName: "leibnizSaysLevel2" */ './view/leibnizSaysGame/Level2/index.vue'),
			props: (route) => ({
				to: route.query.to,
				stage: route.query.stage,
				bg: route.query.bg
			}),
			beforeEnter: (to, from, next) => {
				document.title = 'Quizzort - Leibniz Says';
				next();
			}
		},
		{
			path: '/wall-street-giants/',
			name: 'wallStreetGiants',
			component: () => import(/* webpackChunkName: "wallStreetGiants" */ './view/wallStreetGiants/index.vue'),
			props: (route) => ({
				to: route.query.to,
				stage: route.query.stage,
				bg: route.query.bg
			}),
			beforeEnter: (to, from, next) => {
				document.title = 'Quizzort - Wall Street Giants';
				next();
			}
		},
		{
			path: '/go-for-morkov/',
			name: 'goForMorkov',
			component: () => import(/* webpackChunkName: "goForMorkov" */ './view/goForMorkov/index.vue'),
			props: (route) => ({
				to: route.query.to,
				stage: route.query.stage,
				bg: route.query.bg
			}),
			beforeEnter: (to, from, next) => {
				document.title = 'Quizzort - Go For morkov';
				next();
			}
		},
		{
			path: '/eureka/',
			name: 'eureka',
			component: () => import(/* webpackChunkName: "goForMorkov" */ './view/eureka/index.vue'),
			props: (route) => ({
				to: route.query.to,
				stage: route.query.stage,
				bg: route.query.bg
			}),
			beforeEnter: (to, from, next) => {
				document.title = 'Quizzort - Eureka';
				next();
			}
		}
	]
});

// Routes use for without login. these are the name of routes not path
const openRoutes = [
	'Quizzort',
	'leibnizSaysLevel1',
	'leibnizSaysLevel2',
	'wallStreetGiants',
	'goForMorkov',
	'eureka'
];

router.beforeEach((to, from, next) => {
	$(window).scrollTop(0);
	if (openRoutes.includes(to.name)) {
		next();
	}
});

/** Show loader when moving routes */
router.beforeResolve((to, from, next) => {
	if (to.name) {
		if (openRoutes.includes(to.name)) {
			$('.app-loader.global').show();
		}
		next();
	}
});

/** Hide preloader after each routes */
router.afterEach((to, from) => {
	if (openRoutes.includes(to.name)) {
		$('.app-loader.global').hide();
	}
});

export default router;
